export const useStyles = (theme) => ({
  root: {
    marginTop: 10,
    padding: 10,
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
});
